import { createContext, useContext } from 'react';
import type { Context } from './Translations.types';

const context = createContext(null as any as Context);
export const TranslationsProvider = context.Provider;
export const useTranslations = () => useContext(context);
